import axios from "axios";

const getAuthHeader = (username, password) => {
    const token = Buffer.from(`${username}:${password}`, 'utf8').toString('base64');
    return `Basic ${token}`;
};

function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}

var headers = {
    "Content-Type": "application/json",
    "Authorization": getAuthHeader(getCookie("UserGroup"), getCookie("pwd"))
};

export const CallAPI = async (method, url, request) => {
    try
    {
        const data = JSON.stringify(request);

        let apiResponse = await axios({
            method,
            url,
            headers,
            data,
        });

        return apiResponse.data;
    }
    catch (error)
    {
        return { statuscode: error.response?.status, error: error.response?.data ?? error.message };
    }
};

export const SetAuthHeader = async (userGroup) => {
    headers["Authorization"] = getAuthHeader(userGroup, "");
};

export const GetEnv = () => {
    if (typeof window !== 'undefined') {
        switch (window.location.hostname) {
            case 'localhost':
                return 'dev' //http://localhost:57761
            case 'dashboarduat.cure.com':
                return 'uat'
            case 'dashboardprep.cure.com':
                return 'prod'
            case 'dashboard.cure.com':
                return 'prod'
            default:
                return 'dev'
        }
    }
};